module.exports = __webpack_public_path__ + "static/media/normal.031a669f.ttf";